// Entry point for the build script in your package.json
// import "@hotwired/turbo-rails"
// import "./controllers"
import "./libs/bootstrap_selector_patch"

import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import $ from "./template/jquery"
import "./template"
import "./libs"
import "./function"
import "./datatables"

$(document).ready(function() {
  feather.replace()
})
